(function ($) {
    const $menuButton = $('.site-header__menu-button > button');
    const $nav = $('.site-header__nav');

    $menuButton.on('click', function() {
        $(this).toggleClass('is-active').attr('aria-expanded', $(this).hasClass('is-active'));
        $nav.toggleClass('is-active');
    });

    $('.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();

        $(this).parent().toggleClass('is-active');
    });

})( jQuery )